import axios from '../config/axiosPrivate';

export const getSnapshots = async (params: any) => {
  const response = await axios.get('/snapshots/', { params });
  return response.data;
};

export const createSnapshot = async (payload: any) => {
  const response = await axios.post('/snapshots/', payload);
  return response.data;
};

export const getSnapshot = async (id: number) => {
  const response = await axios.get(`/snapshots/${id}`);
  return response.data;
};

export const updateSnapshot = async (id: number, payload: any) => {
  const response = await axios.put(`/snapshots/${id}`, payload);
  return response.data;
};

export const deleteSnapshot = async (id: number) => {
  const response = await axios.delete(`/snapshots/${id}`);
  return response.data;
};

export const duplicateSnapshot = async (id: number, payload: any) => {
  const response = await axios.put(`/snapshots/${id}/duplicate`, payload);
  return response.data;
};
